import logoUrl from '@/assets/StarlineVentures-Logo.png';
import { cn } from '@/lib/cn';

interface LogoProps {
  className?: string;
}

export default function Logo({ className }: LogoProps) {
  return (
    <a
      href="#top"
      aria-label="Starline Ventures — home"
      className={cn('inline-flex items-center gap-3', className)}
    >
      <img
        src={logoUrl}
        alt=""
        className="h-6 w-auto md:h-8"
        style={{ filter: '' }}
      />
      <span className="sr-only">Starline Ventures</span>
    </a>
  );
}
